'use client';

import React from 'react';
import { Container } from 'components/shared';
import { useTranslations } from 'next-intl';
import { UHLesMillsSubtitle, UHLesMillsTitle } from './typography';
import ImagePlaceholder from './ImagePlaceholder';
import { getLesMillsContent } from './content';
import styles from './UpcomingIntegrations.module.css';

const UpcomingIntegrations = () => {
  const t = useTranslations('uhXLesMills');
  const { upcomingItems } = React.useMemo(() => getLesMillsContent(t), [t]);

  return (
    <section
      className={styles.section}
      role="region"
      aria-labelledby="lm-upcoming-heading"
    >
      <Container>
        <div className={styles.heading}>
          <UHLesMillsTitle id="lm-upcoming-heading">
            {t('upcoming.heading')}
          </UHLesMillsTitle>
          <UHLesMillsSubtitle>{t('upcoming.subtitle')}</UHLesMillsSubtitle>
        </div>
        <div className={styles.grid}>
          {upcomingItems.map((item) => (
            <article className={styles.card} key={item.title}>
              <div className={styles.asset}>
                {item.image ? (
                  <img
                    className={styles.assetImage}
                    src={item.image}
                    alt={item.title}
                  />
                ) : (
                  <ImagePlaceholder label={item.imageLabel} radius={0} fill />
                )}
              </div>
              <div className={styles.text}>
                <h3 className={styles.cardTitle}>{item.title}</h3>
                <p className={styles.cardSubtitle}>{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default UpcomingIntegrations;
